var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultimodal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.17 57.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.58,28.66c0,1.39,.14,2.7,.38,3.94,1.9,.14,4.02,.24,6.49,.27v-8.41c-2.47,.03-4.58,.12-6.47,.26-.25,1.24-.4,2.56-.4,3.94",
    style: {
      fill: "#c42032"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.05,44.11c.13,.01,.26,.01,.4,.02v-8.8c-2.06-.02-4.09-.1-5.84-.21,1.51,4.65,4.27,7.8,5.44,8.99",
    style: {
      fill: "#c42032"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.36,13.28c-.15-.02-.29-.02-.44-.04v8.74c2.06,.02,4.06,.1,5.8,.21-1.5-4.5-4.16-7.65-5.36-8.92",
    style: {
      fill: "#c42032"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.22,34.37c1.57,3.99,4.75,7.16,8.73,8.74-1.44-1.97-3.05-4.72-4-8.19-1.99-.18-3.58-.38-4.73-.55",
    style: {
      fill: "#c42032"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,14.26c-3.98,1.56-7.16,4.71-8.75,8.68,1.15-.17,2.74-.38,4.74-.55,.97-3.41,2.57-6.15,4.01-8.13",
    style: {
      fill: "#c42032"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.11,28.66c0-1.3,.11-2.55,.31-3.73-2.36,.23-4.04,.49-4.97,.65-.2,1.01-.31,2.04-.32,3.11,0,1.05,.11,2.07,.3,3.05,.93,.15,2.63,.41,4.96,.64-.19-1.18-.3-2.41-.3-3.72",
    style: {
      fill: "#c42032"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.66,22.19c1.73-.11,3.73-.18,5.79-.2V13.24c-.14,.01-.29,.01-.43,.03-1.19,1.26-3.86,4.42-5.37,8.92",
    style: {
      fill: "#c42032"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.26,28.66c0,1.31-.11,2.55-.3,3.73,2.3-.22,3.95-.47,4.88-.63,.2-.99,.31-2.02,.31-3.07s-.11-2.11-.31-3.12c-.95-.16-2.61-.4-4.89-.63,.2,1.18,.31,2.42,.31,3.72",
    style: {
      fill: "#c42032"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.39,14.29c1.43,1.98,3.02,4.72,3.99,8.11,1.94,.17,3.51,.37,4.66,.54-1.57-3.94-4.71-7.08-8.65-8.65",
    style: {
      fill: "#c42032"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.64,48.07c-10.7-.01-19.37-8.68-19.38-19.38,0-10.7,8.68-19.38,19.38-19.38s19.38,8.68,19.38,19.38-8.68,19.38-19.38,19.38m-.06-48.07C12.8,0,0,12.8,0,28.59s12.8,28.59,28.59,28.59c15.78-.02,28.57-12.81,28.59-28.59C57.17,12.8,44.37,0,28.59,0",
    style: {
      fill: "#c42032"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.92,35.34v8.79c.14-.01,.27-.02,.41-.03,1.18-1.2,3.91-4.33,5.42-8.97-1.74,.11-3.77,.18-5.83,.21",
    style: {
      fill: "#c42032"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.79,28.66c0-1.38-.15-2.7-.4-3.93-1.9-.14-4-.24-6.47-.27v8.41c2.47-.03,4.6-.13,6.48-.26,.24-1.24,.38-2.55,.38-3.94",
    style: {
      fill: "#c42032"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.44,43.07c3.93-1.58,7.06-4.73,8.62-8.68-1.14,.17-2.69,.37-4.65,.54-.95,3.44-2.54,6.17-3.97,8.13",
    style: {
      fill: "#c42032"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultimodal);
export default __webpack_public_path__ + "static/media/Multimodal.1917bddb340363af584a538cf4170207.svg";
export { ForwardRef as ReactComponent };